import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import { forwardRef } from "react";

const StyledTextField = styled(TextField)(({ theme, error }) => ({
  ...{
    "& .MuiOutlinedInput-root": {
      overflow: "hidden",
    },
    "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: error && theme.palette.error.main,
    },
  },
}));

const CustomizedTextField = forwardRef(
  (
    {
      id,
      name,
      label,
      value,
      onChange,
      onBlur,
      disabled,
      multiline,
      rows,
      error,
      helperText,
      sx,
      InputProps,
      inputProps,
      InputLabelProps,
      required,
      placeholder,
      autoComplete,
      autoFocus,
      margin,
      maxRows,
      minRows,
      type,
      FormHelperTextProps,
      testId,
    },
    ref
  ) => {
    return (
      <StyledTextField
        ref={ref}
        placeholder={placeholder}
        autoComplete={autoComplete || "off"}
        autoFocus={autoFocus}
        size="small"
        fullWidth
        label={label}
        sx={sx}
        InputProps={InputProps}
        inputProps={inputProps}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        type={type || "text"}
        id={id}
        name={name}
        multiline={multiline}
        rows={rows}
        error={error}
        helperText={helperText}
        margin={margin}
        maxRows={maxRows}
        minRows={minRows}
        InputLabelProps={InputLabelProps}
        required={required}
        FormHelperTextProps={FormHelperTextProps}
        data-testid={testId}
      />
    );
  }
);

export default CustomizedTextField;
